import {slideUp, slideDown} from '../services/animations'
import $ from 'jquery'

class ChapterToggle {
	constructor(elem) {
		this.elem = elem
		this.isOpen = elem.classList.contains('open')
		elem.addEventListener('click', this.click.bind(this))
	}

	open() {
		let list = this.elem.parentNode.querySelector('.inset-list')

		if (list === null && $('#is_reload_expand').val()) {
			if ($('.toggle-fas').hasClass('fa-caret-down')) {
				$('.toggle-fas').removeClass('fa-caret-down').addClass('fa-caret-up')
			} else {
				$('.toggle-fas').removeClass('fa-caret-up').addClass('fa-caret-down')
			}
			list = this.elem.parentNode.parentNode.parentNode.querySelector('.inset-list')
		}

		this.elem.classList.add('open')

		this.elem.setAttribute('aria-expanded', 'true')

		slideDown(list, 240)
	}

	close() {
		let list = this.elem.parentNode.querySelector('.inset-list')
		if (list === null && $('#is_reload_expand').val()) {
			if ($('.toggle-fas').hasClass('fa-caret-down')) {
				$('.toggle-fas').removeClass('fa-caret-down').addClass('fa-caret-up')
			} else {
				$('.toggle-fas').removeClass('fa-caret-up').addClass('fa-caret-down')
			}
			list = this.elem.parentNode.parentNode.parentNode.querySelector('.inset-list')
		}
		this.elem.classList.remove('open')
		this.elem.setAttribute('aria-expanded', 'false')

		slideUp(list, 240)
	}

	click(event) {
		event.preventDefault()

		this.isOpen ? this.close() : this.open()
		this.isOpen = !this.isOpen
	}

}

export default ChapterToggle
